import { Alert, Card, Input, TableColumnsConfigType } from '@ui';
import { SelectionTable } from '@/components/form';
import Progressbar from '@/components/ui/progress-bar';
import { Badge, Button, Flex, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { MdOutlineInfo } from 'react-icons/md';

const Overview = () => {
  return (
    <Flex flexDirection="column" gapY={4}>
      <Flex justifyContent="space-between">
        <Flex flexDirection="column" gapY={2}>
          <Text fontSize="sm" fontWeight="bold">
            Key Metrics
          </Text>
          <Input placeholder="Search" />
        </Flex>
        <Flex gapX={2} alignItems="center" marginTop={7}>
          <Input type="date" />
          <Text>to</Text>
          <Input type="date" />
          <Button size="sm" variant="outline" color="fg" borderColor="fg">
            My view
          </Button>
        </Flex>
      </Flex>
      <Flex justifyContent="space-between" gapX={4}>
        <Flex flex={1}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="sm" fontWeight="bold" color="fg.subtle">
                  Kits ready
                </Text>
                <MdOutlineInfo />
              </Flex>
              <Flex gapX={2} fontWeight="bold" alignItems="center">
                <Text fontSize="xl">78%</Text>
                <Text fontSize="xs">(342/440)</Text>
              </Flex>
              <Progressbar value={78} rangeProps={{ bg: 'fg' }} />
              <Text fontSize="xs" color="fg.subtle">
                Ready for installation crews
              </Text>
            </Flex>
          </Card>
        </Flex>
        <Flex flex={1}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="sm" fontWeight="bold" color="fg.subtle">
                  Install progress (week)
                </Text>
                <MdOutlineInfo />
              </Flex>
              <Flex gapX={2} fontWeight="bold" alignItems="center">
                <Text fontSize="xl">88%</Text>
              </Flex>
              {/* TODO: chart */}
              <Text fontSize="xs" color="fg.subtle">
                140/160 frames
              </Text>
            </Flex>
          </Card>
        </Flex>
        <Flex flex={1}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="sm" fontWeight="bold" color="fg.subtle">
                  Supplier on-time
                </Text>
                <MdOutlineInfo />
              </Flex>
              <Flex gapX={2} fontWeight="bold" alignItems="center">
                <Text color="fg.error" fontSize="xl">
                  82%
                </Text>
              </Flex>
              <Flex gapX={2}>
                <Badge bg="bg.emphasized" color="fg">
                  <Text fontSize="xs">85%</Text>
                </Badge>
                <Badge bg="bg.emphasized" color="fg">
                  <Text fontSize="xs">90%</Text>
                </Badge>
              </Flex>
            </Flex>
          </Card>
        </Flex>
        <Flex flex={1}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="sm" fontWeight="bold" color="fg.subtle">
                  First-pass yield
                </Text>
                <MdOutlineInfo />
              </Flex>
              <Flex gapX={2} fontWeight="bold" alignItems="center">
                <Text fontSize="xl">95%</Text>
              </Flex>
              {/* TODO: chart */}
              <Text fontSize="xs" color="fg.subtle">
                No rework rate
              </Text>
            </Flex>
          </Card>
        </Flex>
        <Flex flex={1}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="sm" fontWeight="bold" color="fg.subtle">
                  Defect rate
                </Text>
                <MdOutlineInfo />
              </Flex>
              <Flex gapX={2} fontWeight="bold" alignItems="center">
                <Text color="fg.error" fontSize="xl">
                  1800 ppm
                </Text>
              </Flex>
              <Progressbar value={78} rangeProps={{ bg: 'fg' }} />
            </Flex>
          </Card>
        </Flex>
      </Flex>
      <Flex gapX={4} justifyContent="space-between" fontSize="sm">
        <Flex flexDirection="column" flex={1} gapY={4}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Text fontWeight="bold">Production & Installation</Text>
              <Flex justifyContent="space-between">
                <Text>Install baseline vs actual</Text>
                <Text>342/980</Text>
              </Flex>
              <Progressbar value={78} rangeProps={{ bg: 'fg' }} />
              <Flex gapX={2}>
                <Badge colorPalette="red">
                  <Text>Out of tolerance 3%</Text>
                </Badge>
                <Badge colorPalette="green">
                  <Text>Rework 3%</Text>
                </Badge>
                <Badge colorPalette="red">
                  <Text>PPC 78%</Text>
                </Badge>
              </Flex>
            </Flex>
          </Card>
          <Card>
            <Flex flexDirection="column" gapY={8}>
              <Flex flexDirection="column" gapY={2}>
                <Text fontWeight="bold">Risk & Task</Text>
                <Card>
                  <Flex flexDirection="column" gapY={2}>
                    <Alert
                      marginLeft={-8}
                      status="error"
                      title={
                        <Text>
                          <strong>Design A slipped 2d</strong> (float 0).
                          Predicted install risk +3d. Suggest: re-sequence/add
                          shift.
                        </Text>
                      }
                    />
                    <Flex flexDirection="column" gapY={2} paddingLeft={6}>
                      <Flex gapX={2}>
                        <Badge colorPalette="red">
                          <Text fontSize="xs">Critical</Text>
                        </Badge>
                        <Badge colorPalette="red">
                          <Text fontSize="xs">Schedule</Text>
                        </Badge>
                      </Flex>
                      <Flex gapX={2}>
                        <Button size="xs" bg="fg.warning">
                          Apply fix
                        </Button>
                        <Button
                          size="xs"
                          variant="outline"
                          color="fg.warning"
                          borderColor="fg.warning"
                        >
                          Open schedule comment
                        </Button>
                      </Flex>
                    </Flex>
                  </Flex>
                </Card>
              </Flex>
              <Flex flexDirection="column" gapY={2}>
                <Text fontWeight="bold">Tasks inbox</Text>
                <SelectionTable<TaskInboxProps>
                  columns={taskInboxTableColumns}
                  items={mockTaskInboxData}
                />
              </Flex>
            </Flex>
          </Card>
        </Flex>
        <Flex flexDirection="column" flex={1} gapY={2}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between">
                <Text fontWeight="bold">
                  Supplier reliability (critical parts)
                </Text>
                <Text>Drill down</Text>
              </Flex>
              <SelectionTable<SupplierReliabilityProps>
                columns={supplierReliabilityTableColumns}
                items={mockSupplierReliabilityData}
                hideColumns={['id']}
              />
              <Text color="fg.subtle" fontSize="xs">
                Focus on critical components (frames, glass, anchors, hardware)
              </Text>
            </Flex>
          </Card>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Text fontWeight="bold">Supply risk highlights</Text>
              <Flex justifyContent="space-between">
                <Text>Lead-time variance (anchors)</Text>
                <Badge bg="bg.emphasized" color="fg">
                  <Text>+15%</Text>
                </Badge>
              </Flex>
              <Flex justifyContent="space-between">
                <Text>Glass unit rejects (frame tolerance)</Text>
                <Badge bg="bg.emphasized" color="fg">
                  <Text>+3%</Text>
                </Badge>
              </Flex>
              <Flex justifyContent="space-between">
                <Text>Hardware back orders</Text>
                <Badge bg="bg.emphasized" color="fg">
                  <Text>2 vendrors</Text>
                </Badge>
              </Flex>
            </Flex>
          </Card>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between">
                <Text fontWeight="bold">Next 7 days deliveries</Text>
                <Flex gapX={2}>
                  <Badge bg="bg.emphasized" color="fg">
                    <Text>Heads-up 72%</Text>
                  </Badge>
                  <Badge bg="bg.emphasized" color="fg">
                    <Text>Dock &rarr; stock 2.6h</Text>
                  </Badge>
                </Flex>
              </Flex>
              <SelectionTable<Next7DaysDeliveriesProps>
                columns={next7DaysDeliveriesTableColumns}
                items={mockNext7DaysDeliveriesData}
                hideColumns={['id']}
              />
            </Flex>
          </Card>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default Overview;

type TaskInboxProps = {
  id: string;
  title: string;
  due_date?: Date;
  status: 'Overdue' | 'In Review' | 'Open';
};

type SupplierReliabilityProps = {
  id: number;
  supplier: string;
  otd: number;
  lead_days: number;
  quality_in_ppm: number;
};

type Next7DaysDeliveriesProps = {
  id: number;
  due_date?: Date;
  scope: string;
  destination: string;
  heads_up: 'Yes' | 'No';
  status: string;
};

const taskInboxTableColumns: TableColumnsConfigType<TaskInboxProps> = [
  {
    id: {
      label: 'Id',
      width: '100px',
    },
  },
  {
    title: {
      label: 'Title',
      width: '100px',
    },
  },
  {
    due_date: {
      label: 'Due',
      width: '100px',
      render: (item) => {
        const dueInDays = dayjs(item?.due_date).diff(dayjs(), 'day');
        const isOverdue = item?.status === 'Overdue';
        return (
          <Text>
            {dueInDays ? `${dueInDays}d ${isOverdue ? 'overdue' : ''}` : '-'}
          </Text>
        );
      },
    },
  },
  {
    status: {
      label: 'Status',
      width: '100px',
    },
  },
  {
    id: {
      label: 'Action',
      width: '100px',
      render: () => <Button size="xs">Open</Button>,
    },
  },
];

const supplierReliabilityTableColumns: TableColumnsConfigType<SupplierReliabilityProps> =
  [
    {
      id: {
        label: 'Id',
        width: '100px',
      },
    },
    {
      supplier: {
        label: 'Supplier',
        width: '100px',
      },
    },
    {
      otd: {
        label: 'OTD',
        width: '100px',
        render: (item) => {
          return <Text>{item?.otd}%</Text>;
        },
      },
    },
    {
      lead_days: {
        label: 'Lead (d)',
        width: '100px',
      },
    },
    {
      quality_in_ppm: {
        label: 'Quality',
        width: '100px',
      },
    },
  ];

const next7DaysDeliveriesTableColumns: TableColumnsConfigType<Next7DaysDeliveriesProps> =
  [
    {
      id: {
        label: 'Id',
        width: '100px',
      },
    },
    {
      due_date: {
        label: 'Due',
        width: '150px',
        render: (item) => {
          return (
            <Text>
              {dayjs(item?.due_date).format('DD-MM-YYYY, hh:mm:ss A')}
            </Text>
          );
        },
      },
    },
    {
      scope: {
        label: 'Scope',
        width: '100px',
      },
    },
    {
      destination: {
        label: 'Destination',
        width: '100px',
      },
    },
    {
      heads_up: {
        label: 'Heads-up',
        width: '100px',
        render: (item) => {
          return (
            <Badge bg="bg.emphasized" color="fg">
              <Text>{item?.heads_up}</Text>
            </Badge>
          );
        },
      },
    },
    {
      status: {
        label: 'Status',
        width: '100px',
      },
    },
  ];

const mockTaskInboxData: TaskInboxProps[] = [
  {
    id: 'RFI-021',
    title: 'Task 1',
    status: 'Overdue',
  },
  {
    id: 'SUB-PK-A',
    title: 'Task 2',
    due_date: dayjs().add(2, 'day').toDate(),
    status: 'In Review',
  },
  {
    id: 'ISS-342',
    title: 'Task 3',
    due_date: dayjs().add(5, 'day').toDate(),
    status: 'Overdue',
  },
];

const mockSupplierReliabilityData: SupplierReliabilityProps[] = [
  {
    id: 1,
    supplier: 'Supplier A',
    otd: 99,
    lead_days: 1,
    quality_in_ppm: 99,
  },
  {
    id: 2,
    supplier: 'Supplier B',
    otd: 99,
    lead_days: 1,
    quality_in_ppm: 99,
  },
  {
    id: 3,
    supplier: 'Supplier C',
    otd: 99,
    lead_days: 1,
    quality_in_ppm: 99,
  },
];

const mockNext7DaysDeliveriesData: Next7DaysDeliveriesProps[] = [
  {
    id: 1,
    due_date: new Date(),
    scope: 'Scope 1',
    destination: 'Destination 1',
    heads_up: 'Yes',
    status: 'Overdue',
  },
  {
    id: 2,
    due_date: new Date(),
    scope: 'Scope 2',
    destination: 'Destination 2',
    heads_up: 'No',
    status: 'In Review',
  },
  {
    id: 3,
    due_date: new Date(),
    scope: 'Scope 3',
    destination: 'Destination 3',
    heads_up: 'No',
    status: 'Open',
  },
];
